import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangleIcon } from 'lucide-react';
export function PrerequisiteWarning() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2405">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2406">
        <div className="flex items-start gap-4 p-5 rounded-xl mb-12" style={{
        backgroundColor: '#fffbeb',
        border: '2px solid #c8a84b'
      }} data-id="element-2407">
          <AlertTriangleIcon size={24} className="flex-shrink-0 mt-0.5" style={{
          color: '#c8a84b'
        }} data-id="element-2408" />
          <div data-id="element-2409">
            <p className="text-base font-bold mb-1" style={{
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2410">
              Course Pre-requisites:
            </p>
            <p className="text-base" style={{
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2411">
              Successful completion of{' '}
              <Link to="/cpl-course" className="font-semibold underline hover:opacity-80" style={{
              color: '#1e3d2f'
            }} data-id="element-2412">
                NRA Personal Protection in the Home
              </Link>{' '}
              course or successfully passing the PPOTH pre-course assessment.
            </p>
          </div>
        </div>
      </div>
    </div>;
}